import React from 'react';
import { Box, Chip } from '@mui/material';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import moment from 'moment';

const SHORTCUTS = [
    { label: 'Yesterday', fn: () => { const d = moment().subtract(1, 'day'); return [d, d]; } },
    { label: 'Today', fn: () => { const d = moment(); return [d, d]; } },
    { label: 'Tomorrow', fn: () => { const d = moment().add(1, 'day'); return [d, d]; } },
    { label: 'This week', fn: () => [moment().startOf('isoWeek'), moment().endOf('isoWeek')] },
    { label: '-7 days', fn: () => [moment().subtract(7, 'days'), moment()] },
    { label: '+7 days', fn: () => [moment(), moment().add(6, 'days')] },
    { label: 'This month', fn: () => [moment().startOf('month'), moment().endOf('month')] },
    { label: '-30 days', fn: () => [moment().subtract(30, 'days'), moment()] },
    { label: '+30 days', fn: () => [moment(), moment().add(29, 'days')] },
    { label: 'All future', fn: () => [moment(), moment('2099-12-31')] },
    { label: 'All past', fn: () => [moment('2000-01-01'), moment().subtract(1, 'day')] },
];

const DateRangeFilterPanel = (props) => {
    const { item, applyValue } = props;
    const value = item.value || [null, null];

    const pickerValue = React.useMemo(() => [
        value[0] ? moment(value[0]) : null,
        value[1] ? moment(value[1]) : null,
    ], [value]);

    const handleAccept = React.useCallback((newValue) => {
        const [s, e] = newValue || [null, null];
        if (s && e) {
            applyValue({ ...item, value: [s.format('YYYY-MM-DD'), e.format('YYYY-MM-DD')] });
        }
    }, [applyValue, item]);

    const handleShortcut = React.useCallback((fn) => {
        const [s, e] = fn();
        applyValue({ ...item, value: [s.format('YYYY-MM-DD'), e.format('YYYY-MM-DD')] });
    }, [applyValue, item]);

    const handleClear = React.useCallback(() => {
        applyValue({ ...item, value: undefined });
    }, [applyValue, item]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 0.5 }}>
            <DateRangePicker
                slots={{ field: SingleInputDateRangeField }}
                value={pickerValue}
                onAccept={handleAccept}
                format="MMM D, YYYY"
                slotProps={{
                    textField: {
                        size: 'small',
                        variant: 'outlined',
                        sx: { minWidth: 280 },
                    },
                    actionBar: {
                        actions: ['clear', 'accept'],
                    },
                }}
            />
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {SHORTCUTS.map((sc) => (
                    <Chip
                        key={sc.label}
                        label={sc.label}
                        size="small"
                        variant="outlined"
                        onClick={() => handleShortcut(sc.fn)}
                        sx={{ cursor: 'pointer', fontSize: '0.7rem', height: 22 }}
                    />
                ))}
                {value[0] && (
                    <Chip
                        label="Clear"
                        size="small"
                        color="default"
                        onDelete={handleClear}
                        sx={{ fontSize: '0.7rem', height: 22 }}
                    />
                )}
            </Box>
        </Box>
    );
};

export default DateRangeFilterPanel;
